export default class APICourse {
  constructor(API) {
    this.api = API;
  }
  // Cooldown
  async forceEndCooldown(userID, certID, courseID, content) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/endCooldown`;
    req.body = { ...content };
    return await req.exec();
  }
  // Cooldown
  async unlock(userID, certID, courseID, content) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/unlockCourse`;
    req.body = { ...content };
    return await req.exec();
  }
  // Course Cancelation
  async calcCancelationCharges(userID, certID, courseID, sessionID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/session/${sessionID}/calcCancelationCharges`;
    return await req.exec();
  }
  async cancelEnrol(userID, certID, courseID, sessionID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/session/${sessionID}/cancelEnrol`;
    return await req.exec();
  }
  // overrideResult
  async overrideResult(userID, certID, courseID, content) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/overrideResult`;
    req.body = { ...content };
    return await req.exec();
  }
  // Replace
  async replace(userID, certID, courseID, sessionID, secUserID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/session/${sessionID}/replace/${secUserID}`;
    return await req.exec();
  }
  // Retake
  async retake(userID, certID, courseID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/retake`;
    return await req.exec();
  }
  // Revoke
  async revoke(userID, certID, courseID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/revoke`;
    return await req.exec();
  }
  //Pending Approval Items
  async submit(submitObj, userID, certID, courseID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/pendingApproval/new`;
    req.body = { ...submitObj };
    return await req.exec();
  }
  async review(reviewObj, userID, certID, courseID, paID) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}/pendingApproval/${paID}`;
    req.body = { ...reviewObj };
    return await req.exec();
  }
  // Add
  async add(sessionID, userID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = req.path = `/user/${userID}/session/${sessionID}/add`;
    return await req.exec();
  }
  // Get
  async get(userID, courseID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = req.path = `/user/${userID}/course/${courseID}`;
    return await req.exec();
  }
  // Delete
  async delete(userID, certID, courseID) {
    const req = await this.api.newBaseRequest("DELETE");
    req.path = req.path = `/user/${userID}/certification/${certID}/course/${courseID}`;
    return await req.exec();
  }
}
